export default "__VITE_ASSET__DY_zrE7u__"